// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__2s96H","cell":"classes_cell__1SxsN","download-button":"classes_download-button__3bQ08"};